import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

export const MenuButton = ({
    toggleMenu,
    menuIcon = <MenuIcon sx={{ fontSize: 28, color: '#fff' }} />,
    desktopIcon,
    id = 'menu-button'
}) => {
    return (
        <>
            <Box sx={{ display: { xs: 'flex', desktop: 'none' } }}>
                <IconButton
                    onClick={toggleMenu}
                    sx={{ height: '32px', width: '32px', p: 0 }}
                    disableRipple
                    id={`${id}-mobile`}
                >
                    {menuIcon}
                </IconButton>
            </Box>
            <Box sx={{ display: { xs: 'none', desktop: 'flex' } }}>
                <Button
                    id={id}
                    onClick={toggleMenu}
                    sx={{
                        color: 'white',
                        alignItems: 'center',
                        fontWeight: 500,
                        fontSize: '14px',
                        display: 'flex',
                        gap: '6px',
                        padding: 0,
                        textTransform: 'revert',
                        textDecoration: 'none',
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: 'white'
                        },
                        '&:focus': {
                            outline: 'none',
                            color: 'white'
                        },
                        '&:focus-visible': {
                            outline: '2px solid white',
                            color: 'white'
                        }
                    }}
                    disableRipple
                >
                    {desktopIcon}
                </Button>
            </Box>
        </>
    );
};

MenuButton.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    menuIcon: PropTypes.node,
    desktopIcon: PropTypes.node,
    id: PropTypes.string
};
